import script from "./SaveButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SaveButton.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__